<div class="row g-0 justify-content-center">
    <div class="col col-lg-9 mt-xs-4 py-xs-2">
        <div class="text-center">
            <h1 class="text-primary welcome-intro_title mt-2 mt-md-5">
                Welcome to Purchase App
            </h1>
            <p class="fw-regular fs-14 mb-0">
                Digitize your invoices by uploading the scanned version of your physical invoice. Review the invoice and
                save them in a digital format. You'll have all your invoice related information under one roof.
            </p>
            <h5 class="mt-4 mt-md-5 mb-3">
                Follow below these steps to start your journey.
            </h5>
            <div class="row justify-content-center">
                <div class="col col-md-auto text-center">
                    <pmd-card class="text-center mb-3">
                        <pmd-card-body class="pb-4 pmd-floating-content-wrapper pk-steps-card">
                            <img src="assets/images/upload-v.svg"
                                alt="upload" />
                            <span class="pmd-icon-circle pmd-icon-xs border bg-secondary pmd-floating-content-bc">
                                1
                            </span>
                        </pmd-card-body>
                    </pmd-card>
                    <h5 class="text-dark">Upload</h5>
                </div>
                <div class="col col-md-auto text-center">
                    <pmd-card class="text-center mb-3">
                        <pmd-card-body class="pb-4 pmd-floating-content-wrapper">
                            <img src="assets/images/review-v.svg"
                                alt="upload" />
                            <span
                                class="pmd-icon-circle pmd-icon-xs border bg-secondary pmd-floating-content-bc">2</span>
                        </pmd-card-body>
                    </pmd-card>
                    <h5 class="text-dark">Review</h5>
                </div>
                <div class="col col-md-auto text-center">
                    <pmd-card class="text-center mb-3">
                        <pmd-card-body class="pb-4 pmd-floating-content-wrapper">
                            <img src="assets/images/save-v.svg"
                                alt="upload" />
                            <span
                                class="pmd-icon-circle pmd-icon-xs border bg-secondary pmd-floating-content-bc">3</span>
                        </pmd-card-body>
                    </pmd-card>
                    <h5 class="text-dark">Save</h5>
                </div>
            </div>
            <div class="mt-2 mb-3 my-md-5">
                <button type="button"
                    routerLink="/invoice/upload"
                    pmd-btn
                    pmdRipple
                    color="secondary"
                    class="pmd-btn-icon">
                    Upload Invoice
                </button>
            </div>
        </div>
    </div>
</div>